// Account Popover behavior for desktop
(function() {
  const initializedPopovers = new WeakSet();

  function initializePopover(popover) {
    if (initializedPopovers.has(popover)) return;
    initializedPopovers.add(popover);

    const trigger = popover.querySelector('.account-popover__trigger');
    const panel = popover.querySelector('.account-popover__panel');
    let isOpen = false;
    let closeTimeout;

    function openPopover() {
      clearTimeout(closeTimeout);
      isOpen = true;
      panel.style.opacity = '1';
      panel.style.visibility = 'visible';
      panel.style.transform = 'translateY(0)';
      panel.style.pointerEvents = 'auto';
    }

    function closePopover() {
      closeTimeout = setTimeout(() => {
        isOpen = false;
        panel.style.opacity = '0';
        panel.style.visibility = 'hidden';
        panel.style.transform = 'translateY(-10px)';
        panel.style.pointerEvents = 'none';
      }, 200);
    }

    trigger.addEventListener('mouseenter', openPopover);
    trigger.addEventListener('mouseleave', closePopover);
    panel.addEventListener('mouseenter', openPopover);
    panel.addEventListener('mouseleave', closePopover);

    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      if (isOpen) {
        closePopover();
      } else {
        openPopover();
      }
    });

    document.addEventListener('click', function(e) {
      if (!popover.contains(e.target)) {
        closePopover();
      }
    });
  }

  function initializeAllPopovers() {
    const popovers = document.querySelectorAll('.account-popover');
    popovers.forEach(function(popover) {
      initializePopover(popover);
    });
  }

  initializeAllPopovers();

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('account-popover')) {
            initializePopover(node);
          }
          const nestedPopovers = node.querySelectorAll ? node.querySelectorAll('.account-popover') : [];
          if (nestedPopovers.length > 0) {
            nestedPopovers.forEach(function(popover) {
              initializePopover(popover);
            });
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

// Account trigger: one header button opens either the side flyout (>=900px)
// or the mobile bottom-sheet drawer (<900px). Drawer close (button/overlay/ESC)
// is also owned here; opening the side flyout is delegated to the global
// showSideAccount() defined in simplistic.js.liquid.
(function() {
  let mainDrawer = null;
  let mainOverlay = null;
  let mainCloseButton = null;

  const desktopMQ = window.matchMedia('(min-width: 750px)');

  function initializeMainDrawer() {
    // The original (non-cloned) drawer lives in the main title bar.
    const titleBar = document.querySelector('.toggle-header__title-bar');
    if (!titleBar) return;

    mainDrawer = titleBar.querySelector('.account-drawer');
    if (!mainDrawer) return;

    mainOverlay = mainDrawer.querySelector('.account-drawer__overlay');
    mainCloseButton = mainDrawer.querySelector('.account-drawer__close-button');
  }

  function openDrawer() {
    if (!mainDrawer) return;
    mainDrawer.classList.add('account-drawer--open');
    document.body.classList.add('account-drawer-open');
  }

  function closeDrawer() {
    if (!mainDrawer) return;
    mainDrawer.classList.remove('account-drawer--open');
    document.body.classList.remove('account-drawer-open');
  }

  initializeMainDrawer();

  if (mainCloseButton) {
    mainCloseButton.addEventListener('click', closeDrawer);
  }

  if (mainOverlay) {
    mainOverlay.addEventListener('click', closeDrawer);
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && mainDrawer && mainDrawer.classList.contains('account-drawer--open')) {
      closeDrawer();
    }
  });

  // Delegated so it catches the cloned slide-down header's trigger too.
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-side-account-trigger]');
    if (!trigger) return;
    event.preventDefault();
    if (desktopMQ.matches) {
      if (typeof window.showSideAccount === 'function') {
        window.showSideAccount(true);
      }
    } else {
      openDrawer();
    }
  });

  // If the user resizes across the 900px breakpoint while a panel is open,
  // hand off to the breakpoint-appropriate panel so the UI stays consistent.
  desktopMQ.addEventListener('change', function(event) {
    if (event.matches) {
      if (mainDrawer && mainDrawer.classList.contains('account-drawer--open')) {
        closeDrawer();
        if (typeof window.showSideAccount === 'function') {
          window.showSideAccount(false);
        }
      }
    } else {
      const sideAccount = document.getElementById('side-account');
      if (sideAccount && sideAccount.classList.contains('open')) {
        if (typeof window.hideSideAccount === 'function') {
          window.hideSideAccount();
        }
        openDrawer();
      }
    }
  });
})();
